/* KREUZBERG theme — lightweight vanilla JS, no dependencies */
(function () {
  'use strict';

  /* ---- Scroll reveal ---- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }

  /* ---- Mobile menu toggle ---- */
  document.addEventListener('click', function (e) {
    var burger = e.target.closest('[data-burger]');
    if (burger) {
      var nav = document.querySelector('[data-mobile-nav]');
      if (nav) nav.toggleAttribute('hidden');
    }
  });

  /* ---- Countdown timers ---- */
  function pad(n) { return String(n).padStart(2, '0'); }
  document.querySelectorAll('[data-countdown]').forEach(function (root) {
    var target = new Date(root.getAttribute('data-countdown')).getTime();
    if (isNaN(target)) return;
    var out = {
      d: root.querySelector('[data-cd="days"]'),
      h: root.querySelector('[data-cd="hours"]'),
      m: root.querySelector('[data-cd="minutes"]'),
      s: root.querySelector('[data-cd="seconds"]')
    };
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        root.classList.add('drop--live');
        var live = root.querySelector('[data-live]');
        if (live) live.hidden = false;
        clearInterval(timer);
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (out.d) out.d.textContent = pad(d);
      if (out.h) out.h.textContent = pad(h);
      if (out.m) out.m.textContent = pad(m);
      if (out.s) out.s.textContent = pad(s);
    }
    tick();
    var timer = setInterval(tick, 1000);
  });

  /* ---- Product variant selection ---- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent || '[]');
    var idInput = form.querySelector('[name="id"]');
    var priceOut = form.querySelector('[data-price]');
    var addBtn = form.querySelector('[data-add]');

    function currentSelection() {
      var sel = {};
      form.querySelectorAll('[data-option-index]').forEach(function (input) {
        if (input.checked || input.tagName === 'SELECT') {
          sel[input.getAttribute('data-option-index')] = input.value;
        }
      });
      return sel;
    }

    function findVariant(sel) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return sel[i] === opt; });
      });
    }

    function update() {
      var sel = currentSelection();
      var v = findVariant(sel);
      if (!v) return;
      idInput.value = v.id;
      if (priceOut) priceOut.textContent = v.price;
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addBtn.getAttribute('data-label') : addBtn.getAttribute('data-soldout');
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-index]')) update();
    });
    update();
  });
})();
